// @ts-nocheck
import {
    GetGreifOrderUploadApiParameter,
    uploadOrderCreateCart,
} from "@store/Framework/Services/GreifOrderUploadService";
import { GreifCreateCartUploadModel } from "@store/Framework/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = HasOnError & HasOnSuccess;
type HandlerType = ApiHandlerDiscreteParameter<Parameter, GetGreifOrderUploadApiParameter, GreifCreateCartUploadModel>;

export const DispatchBeginCreateCartUpload: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/GreifOrderUpload/BeginCreateCartUpload",
    });
};

export const CreateCartUpload: HandlerType = async props => {
    const result = await uploadOrderCreateCart();
    if (result.successful) {
        const { webOrderNumber } = result.result;
        props.apiResult = result.result;
        props.dispatch({
            type: "Greif/Components/GreifOrderUpload/DispatchSuccessfulCreateCartResults",
            webOrderNumber,
        });
    } else {
        props.parameter?.onError?.(result as any);
        props.dispatch({
            type: "Greif/Components/GreifOrderUpload/FailedToCreateCartUpload",
        });
    }
};

export const DispatchCompleteCreateCartUpload: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/GreifOrderUpload/CompleteCreateCartUpload",
    });
};

export const chain = [DispatchBeginCreateCartUpload, CreateCartUpload, DispatchCompleteCreateCartUpload];

const createCartUpload = createHandlerChainRunner(chain, "CreateCartUpload");
export default createCartUpload;
